// extracted by mini-css-extract-plugin
export default {"range-slider":"range-slider__range-slider___3ecWh"};